import React from 'react'
import PropTypes from 'prop-types'

import CollapsibleQuestions from './Components/CollapsibleQuestions'

class LoyaltyDiscountsExplanation extends React.Component {
  constructor(props) {
    super(props)

    this.state = { section: this.props.section }
  }

  componentDidMount() {
    const staticPlaceholder = document.getElementsByClassName('js-loyalty-discounts-static')[0]

    if (staticPlaceholder && staticPlaceholder.parentNode) {
      staticPlaceholder.parentNode.removeChild(staticPlaceholder)
    }
  }

  render() {
    return (
      <div>
        <div className="content-heading">
          <h1 className="content-heading__title">CGTrader Loyalty Program</h1>
        </div>

        <div className="text-box">
          <p className="main-text">
            CGTrader Loyalty Program lets you earn CGTrader Points and use them
            to save up to 30% of the order value when purchasing 3D assets on
            CGTrader. CGTrader Points are earned with every purchase you make on
            CGTrader and can be used on future orders.
          </p>
          <CollapsibleQuestions section={this.state.section} />
          <p className="u-text-center">
            For more questions, visit
            {' '}
            <a
              href="https://help.cgtrader.com/hc/en-us/articles/360015116737-What-are-CGTrader-credits-"
              target="_blank"
              rel="noopener noreferrer"
            >
              Help Center
            </a>
          </p>
        </div>
      </div>
    )
  }
}

LoyaltyDiscountsExplanation.propTypes = {
  section: PropTypes.string,
}

LoyaltyDiscountsExplanation.defaultPropTypes = {
  section: '',
}

export default LoyaltyDiscountsExplanation
